import { render, staticRenderFns } from "./invitationAndCouponsCreate.vue?vue&type=template&id=6fa8a21f&scoped=true&"
import script from "./invitationAndCouponsCreate.vue?vue&type=script&lang=js&"
export * from "./invitationAndCouponsCreate.vue?vue&type=script&lang=js&"
import style0 from "./invitationAndCouponsCreate.vue?vue&type=style&index=0&id=6fa8a21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8a21f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDatePicker,VForm,VIcon,VMenu,VRow,VSelect,VTextField})
